import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { usePopperTooltip } from 'react-popper-tooltip';

const MainFilterTooltip = ({
  children,
  label,
  onTooltipClick,
  show,
  config,
}) => {
  const [visible, setVisible] = useState(false);
  const {
    getArrowProps,
    getTooltipProps,
    setTooltipRef,
    setTriggerRef,
  } = usePopperTooltip({...config, interactive: true });

  useEffect(() => {
    let timeout = null;

    if (show) {
      timeout = setTimeout(() => {
        setVisible(true);
      }, 1000);
    } else {
      setVisible(false);
    }

    return () => {
      clearTimeout(timeout);
    }
  }, [show])

  const refElement = document.querySelector('.main-filter');

  if (!refElement) return null;

  return (
    <>
      <div ref={setTriggerRef}>{children}</div>
      {createPortal(
        <>
          {visible && (
            <div
              ref={setTooltipRef}
              onClick={onTooltipClick}
              {...getTooltipProps({ className: 'tooltip-container main-filter-tooltip' })}
            >
              <div {...getArrowProps({ className: 'tooltip-arrow' })} />
              {label}
            </div>
          )}
        </>,
        refElement
      )}
    </>
  );
};

export default MainFilterTooltip;
